import { getBearerToken } from 'common/bearer'

const sendBeacon = (events) => {
  const token = getBearerToken()
  const payload = token ? { authentication: `Bearer ${token}`, events } : { events }
  navigator.sendBeacon('/api/track/events', JSON.stringify(payload))
}

export default sendBeacon
